import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getCustomerPoints, getPointsHistory, setSelectedGoal, CustomerPoints } from '@/lib/db/collections/points';
import { format } from 'date-fns';
import { toast } from 'sonner';
import { useLanguage } from '@/contexts/LanguageContext';

export function useCustomerPoints() {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [points, setPoints] = useState<CustomerPoints | null>(null);
  const [history, setHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchPoints() {
      if (!user) return;
      
      try {
        setLoading(true);
        const pointsData = await getCustomerPoints(user.uid);
        setPoints(pointsData);
        
        const historyData = await getPointsHistory(user.uid);
        setHistory(historyData.map(item => ({
          ...item,
          date: format(item.date.toDate(), 'yyyy-MM-dd')
        })));
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    }

    fetchPoints();
  }, [user]);

  const updateSelectedGoal = async (goalId: string | null, pointsRequired: number | null) => {
    if (!user) return;

    try {
      await setSelectedGoal(user.uid, goalId, pointsRequired);
      setPoints(prev => prev ? { 
        ...prev, 
        selectedGoalId: goalId,
        selectedGoalPoints: pointsRequired 
      } : null);
      toast.success(t('rewards.goalSetSuccess'));
    } catch (err) {
      setError(err as Error);
      toast.error(t('rewards.goalSetError'));
    }
  };

  return {
    points,
    history,
    loading,
    error,
    updateSelectedGoal
  };
} 